// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8baab9ff","455":"853a3a19","977":"8a679d65"}[chunkId] + ".chunk.js";
};